import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/entities/user';
import { trpc } from '@/shared/api';

/**
 * 회원의 상품 상세 조회를 남긴다(products.recordView, SUPER-82 P7). 상세가 정상으로 열렸고(`ready`) 로그인한 일반 회원일 때만
 * 상품 id 마다 한 번 부른다 — StrictMode 두 번 실행·같은 상품 다시 그리기는 ref 가 막는다. 기록 실패는 화면과 무관해 조용히
 * 버린다. 회원 상태(ACTIVE)는 여기서 보지 않는다 — 브라우저의 status 는 로그인 때만 쓰여 가입 직후 인증을 마친 회원도 오래된 값을
 * 가질 수 있다. ACTIVE·하루 1회·관리자 제외·공개 상품 판정은 서버가 한다(여기 거름은 비회원·관리자 요청을 아끼는 것뿐이다).
 * 이 호출은 공개 상세 화면에서 처음 나가는 인증 호출이라, 재발급 토큰이 이미 죽은 회원은 상세 화면을 여는 순간 기존 재발급 링크가
 * 로그아웃시킨다. 받아들이기로 했다 — 세션은 이미 끝나 있었고, 화면은 비회원으로 다시 불러온다.
 */
export const useRecordProductView = (productId: string, ready: boolean): void => {
  const canRecord = useAuthStore((state) => state.isAuthenticated && state.user?.role === 'USER');
  const { mutateAsync } = trpc.products.recordView.useMutation();
  const recordedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!ready || !canRecord || recordedFor.current === productId) return;
    recordedFor.current = productId;
    // 결과는 mutation 훅 상태가 아니라 promise 로 다룬다 — StrictMode 재마운트에서 옵저버가 떨어져도 영향이 없다.
    mutateAsync({ productId }).catch(() => undefined);
  }, [ready, canRecord, productId, mutateAsync]);
};
